<template>
    <div class="model-carousel">
        <div class="container">
            <div v-swiper:mySwiper="swiperOption" @click-slide="handleClickSlide">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" v-for="(model, index) in models" :key="index" :data-index="index">
                        <div class="banner-block">
                            <img class="play-btn" :src="asset('/images/motor-show-play-video.svg')" v-if="model.video_link" />
                            <img
                                class="logo"
                                :src="asset(model.model.logo_image_light_path)"
                                v-if="model.model && model.logo_setting == 'light'"
                            />
                            <img
                                class="logo"
                                :src="asset(model.model.logo_image_path)"
                                v-if="model.model && model.logo_setting == 'dark'"
                            />
                            <img class="banner" :src="asset(model.thumbnail_model_promotion)" />
                        </div>
                    </div>
                </div>
            </div>

            <div class="swiper-pagination-main-block model-pagination">
                <div class="pagination-arrow prev">
                    <img class="pagination-icon" :src="asset('/images/icon_back.svg')" />
                </div>
                <div class="pagination-arrow next">
                    <img class="pagination-icon" :src="asset('/images/icon_next.svg')" />
                </div>
            </div>
        </div>

        <div class="swiper-pagination-block model-pagination">
            <div class="pagination-arrow prev">
                <img class="pagination-icon" :src="asset('images/chevron-left-grey.svg')" />
            </div>

            <div class="swiper-pagination"></div>

            <div class="pagination-arrow next">
                <img class="pagination-icon" :src="asset('images/chevron-right-grey.svg')" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        models: {
            type: Array
        }
    },

    data() {
        return {
            swiperOption: {
                pagination: {
                    el: ".model-pagination .swiper-pagination",
                    type: "fraction"
                },
                navigation: {
                    nextEl: ".model-pagination .next",
                    prevEl: ".model-pagination .prev"
                },
                slidesPerView: "auto",
                spaceBetween: 12,
                freeMode: true,
                preventClicks: false,

                breakpoints: {
                    768: {
                        pagination: {
                            el: ".model-pagination .swiper-pagination",
                            clickable: true,
                            type: "bullets"
                        }
                    },

                    1200: {
                        pagination: {
                            el: ".model-pagination .swiper-pagination",
                            clickable: true,
                            type: "bullets"
                        },
                        spaceBetween: 30,
                        slidesPerView: 3,
                        slidesPerGroup: 3,
                        freeMode: false,
                        allowTouchMove: false
                    }
                }
            }
        };
    },

    methods: {
        handleClickSlide(index, realIndex) {
            let item = realIndex !== null ? realIndex : index;
            this.$emit("popup", this.models[item]);
            let slug = this.models[item].model ? this.models[item].model.slug : this.models[item].car_model_category;
        }
    }
};
</script>

<style lang="scss">
@import "../../../sass/variables";

* {
    :focus {
        outline: none;
    }
}

.model-carousel {
    margin-top: 20px;
    margin-bottom: 20px;
    overflow: hidden;

    @media ($md) {
        margin-top: 40px;
        margin-bottom: 21px;
    }

    .container {
        position: relative;
    }

    .swiper-container {
        overflow: visible;

        @media ($xl) {
            overflow: hidden;
        }

        .swiper-wrapper {
            .swiper-slide {
                width: 55vw;

                @media ($md) {
                    width: 40vw;
                }

                @media ($xl) {
                    width: 100%;
                    height: 470px;
                }

                .banner-block {
                    cursor: pointer;

                    .play-btn {
                        position: absolute;
                        left: 50%;
                        top: 50%;
                        transform: translate(-50%, -50%);
                        width: 40px;
                        height: 40px;

                        @media ($md) {
                            width: 93px;
                            height: 93px;
                        }
                    }

                    .logo {
                        position: absolute;
                        top: 20px;
                        left: 20px;
                        height: 15px;

                        @media ($md) {
                            top: 30px;
                            height: 21px;
                        }
                    }

                    .banner {
                        width: 100%;
                        height: 100%;
                        object-fit: cover;
                    }

                    .title {
                        position: absolute;
                        bottom: 3px;
                        font-family: $font-bold;
                        font-size: 18px;
                        margin-left: 25px;
                        margin-right: 25px;
                        line-height: 1.2;
                        white-space: pre-wrap;

                        @media ($md) {
                            margin-left: 30px;
                            font-size: 24px;
                        }
                    }
                }
            }
        }
    }

    .swiper-pagination-main-block {
        display: none;

        @media ($md) {
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
            display: flex;
            justify-content: space-between;
            width: 100%;
            cursor: pointer;
        }

        .pagination-arrow {
            position: relative;
            transition: opacity 0.3s;

            &:hover {
                opacity: 0.8;
            }

            &.prev {
                left: -75px;
            }

            &.next {
                right: -75px;
            }

            .pagination-icon {
                width: 70px;
                height: 53px;
            }
        }
    }

    .swiper-pagination-block {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 20px;

        @media ($md) {
            margin-top: 20px;
        }

        .pagination-arrow {
            width: 60px;
            height: 60px;
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            background-color: #e3e3e3;

            @media ($md) {
                background-color: transparent;
            }

            .pagination-icon {
                width: 15px;
                height: 21px;
            }
        }

        .swiper-pagination {
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            bottom: auto;

            &.swiper-pagination-fraction {
                flex: 1 1 auto;
                width: auto;
                font-size: 30px;
            }

            .swiper-pagination-bullet {
                border-radius: 0;
                width: 40px;
                height: 7px;
                margin: 0 3.5px;

                &-active {
                    background-color: $primary-red;
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/motor-show/ModelCarousel.vue